// localStorage Constants
export const TOKEN = "token";
export const USER_ID = "user_id";
export const FIRST_NAME = "first_name";
export const CLIENT_ID = "client_id";
export const ORG_ID = "org_id";

// API Constants
export const MYM_WEB_LOGIN = "mym_web_login";
